(() => {
  const init = (root) => {
    root.querySelectorAll('[data-da-toc]').forEach((toc) => {
      const scope = toc.closest('.da-reading');
      const content = scope && scope.querySelector('[data-da-content]');
      const list = toc.querySelector('[data-da-toc-list]');
      if (!content || !list) return;
      const headings = [...content.querySelectorAll('h2')];
      if (!headings.length) {
        toc.hidden = true;
        return;
      }
      list.innerHTML = '';
      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = `article-section-${index + 1}`;
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim();
        item.appendChild(link);
        list.appendChild(item);
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
